module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_playworks_m.b342a8479575bb681deb96fb7c172879.png";